// extracted by mini-css-extract-plugin
module.exports = {"policy":"policy_policy__1CUUa","bgImg":"policy_bgImg__DynSF","content":"policy_content__2pKgd"};